var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcInsta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 23.5,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.9184 10H18.0816C13.6185 10 10 13.6185 10 18.0816V29.9184C10 34.3815 13.6185 38 18.0816 38H29.9184C34.3815 38 38 34.3815 38 29.9184V18.0816C38 13.6185 34.3815 10 29.9184 10ZM35.4225 30.1266C35.4225 33.0888 33.0214 35.4919 30.0572 35.4919H17.9428C14.9806 35.4919 12.5775 33.0908 12.5775 30.1266V18.0122C12.5775 15.05 14.9786 12.6469 17.9428 12.6469H30.0572C33.0194 12.6469 35.4225 15.048 35.4225 18.0122V30.1266Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 16.8067C19.987 16.8067 16.7354 20.0603 16.7354 24.0714C16.7354 28.0824 19.989 31.3361 24 31.3361C28.0111 31.3361 31.2647 28.0824 31.2647 24.0714C31.2647 20.0603 28.0111 16.8067 24 16.8067ZM24 28.7823C21.3987 28.7823 19.2911 26.6727 19.2911 24.0734C19.2911 21.474 21.4007 19.3644 24 19.3644C26.5994 19.3644 28.709 21.474 28.709 24.0734C28.709 26.6727 26.5994 28.7823 24 28.7823Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5065 18.2223C32.4416 18.2223 33.1997 17.4642 33.1997 16.5291C33.1997 15.5939 32.4416 14.8358 31.5065 14.8358C30.5713 14.8358 29.8132 15.5939 29.8132 16.5291C29.8132 17.4642 30.5713 18.2223 31.5065 18.2223Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInsta);
export default __webpack_public_path__ + "static/media/ic-insta.68dc967f3f1aee91eb64d830e014e6ff.svg";
export { ForwardRef as ReactComponent };